import { Trans, useTranslation } from 'next-i18next';
import { ErrorMessage } from '../errorMessage/ErrorMessage';

type StockAvailabilityInfoProps = {
  message?: string | null;
  size?: string | null;
  width?: string | null;
  testId?: string | null;
};

export function StockAvailabilityInfo({ message, size, width, testId }: StockAvailabilityInfoProps) {
  const { t } = useTranslation('lib-products-common');
  if (!message || !testId) {
    return null;
  }
  if (size && width) {
    return (
      <ErrorMessage testId={testId}>
        <Trans i18nKey={message} t={t} values={{ size, width }} />
      </ErrorMessage>
    );
  }
  return <ErrorMessage testId={testId}>{t(message)}</ErrorMessage>;
}
